(function () {
    document.addEventListener('DOMContentLoaded', function (event) {
        let forms = document.querySelectorAll('[data-filter]');
        let i;
        for (i = 0; i < forms.length; i++) {
            let form = forms[i];
            let targetId = form.getAttribute('data-filter-target');
            let target = document.getElementById(targetId);
            let filterFields = <NodeListOf<HTMLInputElement>>form.querySelectorAll('input');
            let airlineFilter = <HTMLInputElement>form.querySelector('[data-filter-type="airline"]');
            let parentBlocks = <NodeListOf<HTMLElement>>target.querySelectorAll('[data-filter-hidewhenempty="1"]');
            let items = <NodeListOf<HTMLElement>>target.querySelectorAll('[data-filter-item]');

            let j;
            for (j = 0; j < items.length; j++) {
                items[j].setAttribute('data-display-original', items[j].style.display);
            }

            for (j = 0; j < filterFields.length; j++) {
                filterFields[j].addEventListener('keyup', function (event) {
                    let activeFilters = [];
                    if (airlineFilter) {
                        let filterValue = airlineFilter.value.toUpperCase().trim();
                        if (filterValue !== airlineFilter.value) {
                            airlineFilter.value = filterValue;
                        }
                        if (filterValue.length === 2) {
                            activeFilters.push({
                                name: 'airline-iata',
                                value: filterValue
                            });
                        } else if (filterValue.length === 3) {
                            if (filterValue.match(/\d{3}/)) {
                                activeFilters.push({
                                    name: 'airline-bsp',
                                    value: filterValue
                                });
                            } else {
                                activeFilters.push({
                                    name: 'airline-icao',
                                    value: filterValue
                                });
                            }
                        }

                        let k;
                        for (k = 0; k < filterFields.length; k++) {
                            if (filterFields[k].getAttribute('data-filter-type') == 'airline') {
                                continue;
                            }
                            filterValue = filterFields[k].value.trim();
                            if (filterValue.length > 0) {
                                activeFilters.push({
                                    name: filterFields[k].getAttribute('data-filter-name'),
                                    value: filterValue,
                                    operation: function (fieldValue: string, compareValue: string) {
                                        let regExp = new RegExp(compareValue, 'i');
                                        return fieldValue.search(regExp) >= 0;
                                    }
                                });
                            }
                        }
                    }

                    let k;
                    if (Element.prototype.closest) {
                        for (k = 0; k < parentBlocks.length; k++) {
                            parentBlocks[k].style.display = 'none';
                        }
                    }
                    let defaultOperation = function (fieldValue: string, compareValue: string) {
                        return fieldValue === compareValue;
                    }
                    for (k = 0; k < items.length; k++) {
                        let j;
                        let active = true;
                        for (j = 0; j < activeFilters.length; j++) {
                            let operation = activeFilters[j].operation ?? defaultOperation;
                            let fieldValue = items[k].getAttribute('data-filter-' + activeFilters[j].name);
                            active = active && operation(fieldValue, activeFilters[j].value);
                        }
                        if (active === true) {
                            items[k].style.display = items[k].getAttribute('data-display-original');
                            if (Element.prototype.closest) {
                                let parent = <HTMLElement>items[k].closest('[data-filter-hidewhenempty="1"]');
                                if (parent) {
                                    parent.style.display = 'block';
                                }
                            }
                        } else {
                            items[k].style.display = 'none';
                        }
                    }
                });
            }
        }
    });
}());

